// styles
import { styled } from '@mui/material';

export const StyledDojoHost = styled('div')({
  height: '100%'
});
